import { render, staticRenderFns } from "./AttributionBlackList.vue?vue&type=template&id=272f9666"
import script from "./AttributionBlackList.vue?vue&type=script&lang=js"
export * from "./AttributionBlackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports